import { render, staticRenderFns } from "./TabbedContainer.vue?vue&type=template&id=9a7e3f80&lang=pug&"
import script from "./TabbedContainer.vue?vue&type=script&lang=js&"
export * from "./TabbedContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabbedContainer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports